import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

// Super Admin: where "Pay by credit card" for the SAG balance goes. Never CIArb's own gateway (that pays CIArb).
export function SagBillingCard() {
  const [link, setLink] = useState("");
  const [saved, setSaved] = useState(null);
  useEffect(() => { api.get("/admin/sag-fees/payment-destination").then((r) => { setLink(r.data.payment_link); setSaved(r.data.payment_link); }).catch(() => setSaved("")); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/admin/sag-fees/payment-destination", { payment_link: link }); setSaved(data.payment_link); toast.success("SAG billing saved"); } catch (err) { toast.error(errMsg(err)); }
  };
  if (saved === null) return null;
  return (
    <section className="admin-card" data-testid="sag-billing-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-lg text-navy">SAG billing</h2>
        <span className={`rounded px-2 py-1 text-xs font-semibold ${saved ? "bg-emerald-100 text-emerald-900" : "bg-gray-200"}`} data-testid="sag-billing-status">{saved ? "Card payment link configured" : "Card payment to SAG – setup pending"}</span>
      </div>
      <p className="mt-2 text-sm text-gray-600">Card payments of the SAG processing-fee balance go to Sebastian Alliance Group, never through CIArb&apos;s own card gateway. Paste the payment link SAG provides (https). Opening it never marks anything paid: SAG confirms receipt.</p>
      <form onSubmit={save} className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-end">
        <div className="flex-1"><label htmlFor="sag-link" className="field-label">SAG payment link</label>
          <input id="sag-link" type="url" className="field-input" value={link} onChange={(e) => setLink(e.target.value)} placeholder="https://" data-testid="sag-billing-link-input" /></div>
        <button className="btn-navy" data-testid="sag-billing-save-btn">Save</button>
      </form>
    </section>
  );
}
